// Module
var code = `<div class="modal-dialog modal-lg margin-bottom" role="document" id="patchSyntaxDialog">
    <div class="modal-content">
        <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><i class="icon-cancel"></i></button>
            <div class="row margin-top">
                <div class="col-xs-12 col-lg-6">
                    <h3>Sample scripts</h3>
                    <div data-bind="foreach: \$data.constructor.samples">
                        <div class="margin-top" data-bind="text: title"></div>
                        <pre class="margin-bottom copy-area"><a href="#" class="copy-button-hidden" title="Copy code sample" data-bind="click: _.partial(\$root.copySample, title)"><i class="icon-copy"></i></a><span data-bind="html: html"></span></pre>
                    </div>
                </div>
                <div class="col-xs-12 col-lg-6">
                    <h3>Methods signature</h3>
                    <div class="text-left margin-top">
                        <div>The following functions can be used under <code>update</code> in the patch script:</div>
                        <small>See RavenDB online documentation for the full list.</small>
                        <div data-bind="compose: \$root.scriptFunctionsSyntaxView"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;